import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentcolor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M6.667 16.665H5.333a2 2 0 0 1-2-2V5.332a2 2 0 0 1 2-2H7.5m-.833 13.333v-4.833a1 1 0 0 1 1-1h4.666a1 1 0 0 1 1 1v4.833m-6.666 0h6.666m0 0h1.334a2 2 0 0 0 2-2V7.494a2 2 0 0 0-.586-1.414l-2.162-2.162a2 2 0 0 0-1.419-.586m0 0v2.333a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1V3.332m5 0h-5"
    }, null, -1)
  ]))]))
}
export default { render: render }